import BaseTable from './BaseTable';


class MenuTable extends BaseTable {

}

export default MenuTable;
